import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as fa from '@fortawesome/free-solid-svg-icons'
import * as generic from './generic.js';

export default function TabContainer(props) {
	const children = generic.arrayWrap(props.children).filter(element => !!element);

	const [url, setUrl] = useState(props.url || children[0].props.url);
	const [expand, setExpand] = useState(false);

	if (!children.find(tab => (tab.props.url === url))) {
		setUrl(children[0].props.url);
	}

	let content =  (
		<>
		{props.hideTab || process.env.REACT_APP_HIDE_TAB ? null : (
			<nav data-expand={expand} className={(children.length > 1 ? "" : "hide-nav") + " " + (props.className || "")}>
				<div>
					{children.map((tab, i) => {
						const onClick = function() { setUrl(tab.props.url); if (props.onClick) { props.onClick(tab, i); } };

						return <div key={i}><a onClick={onClick} key={tab.props.url} href={props.baseUrl + tab.props.url} data-selected={url === tab.props.url}>{tab.props.name}</a></div>;
					}) }
					<span className="plus-icon" onClick={() => { setExpand(!expand); }}><FontAwesomeIcon icon={expand ? fa.faMinus : fa.faPlus}/></span>
				</div>
			</nav>)
		}
		{
			children.map((tab, i) => {
				if (tab.props.url === url) {
					return tab.props.children;
				}
				return "";
			})
		}
		</>
	);
	if (props.hasScroll) {
	return (
		<div className="scroll-container e100">
			{content}
		</div>
	);
	}
	return content;
}

TabContainer.Tab = function(props) {
	return props.children;
}
